import { Award } from "src/domain/award";
import data from "src/services/data";

export const useAwards = () => {
  return {
    getAwardsPerSubscriberLevel(type: string | null): Award[] {
      if (type) return data[type];
      return [];
    },
  };
};
